import React from 'react'
import './Welcome.css'
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
const Welcome = (props) => {


  return (
    <div>
      <Typography.Title level={2}>Добро пожаловать в Личный кабинет</Typography.Title>
      <Typography.Title level={2}>Здесь Вы можете: </Typography.Title>
      <table align="center">
        <tbody>
          <tr><td align="left"><Typography.Title level={3}>1. <Link to={`/amount`}>Скачать платежный документ</Link></Typography.Title></td></tr>
          <tr><td align="left"><Typography.Title level={3}>2. <Link to={`/amount`}>Оплатить жилищные услуги, коммунальные услуги, капитальный ремонт с помощью банковских карт</Link></Typography.Title></td></tr>
          <tr><td align="left"><Typography.Title level={3}>3. <Link to={`/counters`}>Передать показания приборов учета</Link></Typography.Title></td></tr>
          <tr><td align="left"><Typography.Title level={3}>4. <Link to={`/users`}>Подключить регулярную отправку платежных документов на Вашу электронную почту</Link></Typography.Title></td></tr>
        </tbody>
      </table>

    </div>
  )

}
export default Welcome;